import { Address } from '../generic/Address';
import { Location } from '../generic/Location';

export interface BranchesRequestData {
  branches: string[];
}

export interface OptionalRequestData {
  page?: number;
  radius?: number;
  distanceTo?: ym.provider.LatLngLiteral;
  countryCode?: string;
  isoLocale?: string;
  freeFilter?: string;
  companyNameFilter?: string;
  fitBounds?: boolean;
  dataFilters?: string | void;
}

export function hasBranches(obj: any): obj is BranchesRequestData {
  return obj && obj.type && obj.branches && obj.branches.length;
}

export function hasOptionalRequestData(obj: any): obj is OptionalRequestData {
  return obj && obj.type;
}

export function isAddressRequest(obj: any): obj is AddressRequestData {
  return obj && obj.type && obj.type === 'Address';
}

export function isLocationRequest(obj: any): obj is LocationRequestData {
  return obj && obj.type && obj.type === 'Location';
}

export function isPositionRequest(obj: any): obj is PositionRequestData {
  return obj && obj.type && obj.type === 'Position';
}

export function isRectangleRequest(obj: any): obj is RectangleRequestData {
  return obj && obj.type && obj.type === 'Rectangle';
}

export function isCountryRequest(obj: any): obj is CountryRequestData {
  return obj && obj.type && obj.type === 'Country';
}

export function isIdRequest(obj: any): obj is IdRequestData {
  return obj && obj.type && obj.type === 'Id';
}

export interface AddressRequestData extends OptionalRequestData {
  type: 'Address';
  address: Address;
}

export interface LocationRequestData extends Location, OptionalRequestData {
  type: 'Location';
}

export interface PositionRequestData extends OptionalRequestData {
  type: 'Position';
  center: ym.provider.LatLngLiteral;
}

export interface RectangleRequestData extends OptionalRequestData {
  type: 'Rectangle';
  bounds: ym.provider.LatLngBoundsLiteral;
}

export interface CountryRequestData extends OptionalRequestData {
  type: 'Country';
  countryCode: string;
}

export interface IdRequestData extends OptionalRequestData {
  type: 'Id';
  id: string;
}
